



import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  panels: [],
  active: [],
  activeItem: [], // Aunque no se use más, se mantiene por compatibilidad estructural.
};

const panelsSlice = createSlice({
  name: 'panels',
  initialState,
  reducers: {

    panelsLoad: (state, action) => {
      // Verificar que el payload es un array válido
      if (Array.isArray(action.payload)) {
        // Crear un nuevo array con los paneles actualizados
        state.panels = action.payload.map(panel => ({ ...panel }));
      }
    },


    panelsActive: (state, action) => {
      state.active = [
        ...action.payload
          .filter(element => !state.active.some(e => e.id === Number(element.id)))
          .map(element => ({ id: Number(element.id) })),
        ...state.active.filter(element => !action.payload.some(e => Number(e.id) === element.id))
      ];
    },

    panelsUpdate: (state, action) => {
      const updatedPanels = action.payload;

      state.panels = state.panels.map(p => {
        const updated = updatedPanels.find(up => up.id === p.id);
        return updated ? { ...updated } : p; // ← Se crea nueva referencia
      });

      state.active = state.active.map(p => {
        const updated = updatedPanels.find(up => up.id === p.id);
        return updated ? { id: updated.id } : p;
      });
    },

    panelsRemoveActive: (state) => {
      state.active = [];
    },

    panelsRemoveActiveById: (state, action) => {
      const itemId = Number(action.payload);
      state.active = state.active.filter(item => item.id !== itemId);
    },

    panelsActiveItem: (state, action) => {
      const newItem = { id: Number(action.payload.id) };
      const exists = state.active.some(item => item.id === newItem.id);

      if (!exists) {
        state.active = [...state.active, newItem];
      }
    },

    panelsRemoveActiveItemById: (state, action) => {
      const itemId = Number(action.payload);
      state.active = state.active.filter(item => item.id !== itemId);
    },

    panelsRemoveActiveItem: (state) => {
      state.active = [];
    },

    panelsLogoutCleaning: () => initialState,
  },
});

export const {
  panelsLoad,
  panelsActive,
  panelsUpdate,
  panelsRemoveActive,
  panelsActiveItem,
  panelsRemoveActiveItemById,
  panelsRemoveActiveItem,
  panelsLogoutCleaning,
} = panelsSlice.actions;

export default panelsSlice.reducer;

